import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$2 } from './button-base2.js';
import { d as defineCustomElement$1 } from './nl-select2.js';

import { baseCss } from './css.js';
const nlSignupCss = baseCss;

const NlSignupStyle0 = nlSignupCss;

const NlSignup = /*@__PURE__*/ proxyCustomElement(class NlSignup extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlSignup = createEvent(this, "nlSignup", 7);
        this.nlCheckSignup = createEvent(this, "nlCheckSignup", 7);
        this.fetchHandler = createEvent(this, "fetchHandler", 7);
        this.titleSignup = 'Create keys with key store';
        this.description = 'Choose some username and a key store service.';
        this.bunkers = 'nsec.app,highlighter.com';
        this.isAvailable = false;
    }
    formatServers(bunkers) {
        return bunkers.split(',').map(d => ({
            name: '@' + d,
            value: d,
        }));
    }
    handleInputChange(event) {
        state.nlSignup.signupName = event.target.value;
        this.nlCheckSignup.emit(`${event.target.value}@${state.nlSignup.domain}`);
    }
    handleDomainSelect(event) {
        state.nlSignup.domain = event.detail;
        this.nlCheckSignup.emit(`${state.nlSignup.signupName}@${event.detail}`);
    }
    handleCreateAccount(e) {
        e.preventDefault();
        this.nlSignup.emit(`${state.nlSignup.signupName}@${state.nlSignup.domain}`);
    }
    watchBunkersHandler(newValue) {
        state.nlSignup.servers = this.formatServers(newValue);
    }
    componentWillLoad() {
        state.nlSignup.servers = this.formatServers(this.bunkers);
    }
    render() {
        return (h(Fragment, { key: '558e55ea3a7177a7e035e82c1bbdf522fb2efeb4' }, h("div", { key: '8f04f68da63de9317a9ea7e1b425a54fef58905e', class: "p-4 overflow-y-auto" }, h("h1", { key: 'a8bc4c25348f8d0416679212ba2344a3ca9a78f0', class: "nl-title font-bold text-center text-2xl" }, this.titleSignup), h("p", { key: '4e978b75b8ad51e1bc9b0ab5412bd96c21343d9d', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, this.description)), h("div", { key: '34b45813498214aedea41061bb60b170cdf1bc35', class: "max-w-72 mx-auto" }, h("div", { key: '7a9cc7d8acacebf5001d98982e9f140164a2daf3', class: "relative mb-2" }, h("input", { key: 'e7f48804f026d19d8bff09c59854dd55de8b6f54', onInput: e => this.handleInputChange(e), type: "text", class: "nl-input peer py-3 px-4 ps-11 block w-full border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent", placeholder: "Name", value: state.nlSignup.signupName }), h("div", { key: '1a3c7346fa66174c33110c7523e6598c091abeae', class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none" }, h("svg", { key: 'edaa9b8e76f3bc2c4a34d8d1fe20536571ef5749', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "2", stroke: this.isAvailable ? '#00cc00' : 'currentColor', class: "flex-shrink-0 w-4 h-4 text-gray-500" }, h("path", { key: '3e0d1b3d4c9d6b2d4ffc44e699c1545b68173d67', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" })))), h("div", { key: 'c0b07eb2e657adf2dbfc95fa3bf6351a6beda00a', class: "mb-2" }, h("nl-select", { key: '632e99d1d1e074ed8f9383c0f7bd38f3415a3305', onSelectDomain: e => this.handleDomainSelect(e), selected: 0, options: state.nlSignup.servers })), h("div", { key: '96cc25d6bf9e12eb950e81dc046bebd2998f117f', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: '7cd9f343b92a75efb8c26db31afa19a734893449', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: '491cbb2cad036c958624947160014d3a0f12125e', disabled: state.isLoading, onClick: e => this.handleCreateAccount(e), titleBtn: "Create profile" }, state.isLoading ? (h("span", { slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })) : (h("svg", { slot: "icon-start", style: { display: 'none' }, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" })))))));
    }
    static get watchers() { return {
        "bunkers": ["watchBunkersHandler"]
    }; }
    static get style() { return NlSignupStyle0; }
}, [0, "nl-signup", {
        "titleSignup": [1, "title-signup"],
        "description": [1],
        "bunkers": [1],
        "isAvailable": [32]
    }, undefined, {
        "bunkers": ["watchBunkersHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-signup", "button-base", "nl-select"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-signup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlSignup);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "nl-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlSignup as N, defineCustomElement as d };

//# sourceMappingURL=nl-signup2.js.map